let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2x2BK")).then(() => parcelRequire('h95YY'));